<template>
  <div class="control">
    <div class="control__title">
      <div class="title">
        <div class="title-text">
          {{ title }}
        </div>
        <div class="control__helper">
          <div
            class="control__trigger"
            @mouseover="showHint = true"
            @mouseleave="showHint = false"
          >
            <img
              src="https://sirv.sirv.com/website/theme2/icon/question.svg"
              :alt="hint"
            >
          </div>
          <div
            v-show="showHint"
            class="hint"
          >
            {{ hint }}
          </div>
        </div>
      </div>
    </div>
    <div class="control__action">
      <div class="control__choice">
        <div
          class="fakeoverlay"
          :class="{disabled: !radioStatus}"
          @click="radioStatus =! radioStatus"
        />
        <el-radio
          v-for="(radioValue, index) in radioOption"
          :key="index"
          v-model="value"
          :disabled="!radioStatus"
          :label="radioValue.value"
          @change="changeOption"
        >
          {{ radioValue.value }}
        </el-radio>
        <el-input
          v-if="value === 'frame' && radioStatus === true"
          v-model="num"
          step="0.1"
          :min="min"
          :max="max"
          type="number"
          :placeholder="`e.g. 4.17`"
          class="control__aditional"
          :disabled="!radioStatus"
          @change="changeOption"
        />
        <el-input
          v-else-if="value === 'image url' && radioStatus === true"
          v-model="text"
          type="text"
          :placeholder="textPlaceholder"
          class="control__aditional"
          :disabled="!radioStatus"
          @change="changeOption"
        />
      </div>
      <el-checkbox
        v-model="radioStatus"
        class="control__checkbox"
        @change="changeOption"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'RadioExtendedNumText',
  props: {
    title: {
      type: String,
      default: ''
    },
    default: {
      type: String,
      default: ''
    },
    numDefault: {
      type: Number,
      default: 0
    },
    textDefault: {
      type: String,
      default: ''
    },
    textPlaceholder: {
      type: String,
      default: ''
    },
    hint: {
      type: String,
      default: ''
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 0
    },
    status: {
      type: Boolean
    },
    options: {
      type: Array,
      default: Function
    },
    parameter: {
      type: String,
      default: ''
    },
    eventClick: {
      type: Boolean
    }
  },
  data () {
    return {
      value: this.default,
      num: null,
      text: this.textDefault,
      radioStatus: this.status,
      radioOption: this.options,
      showHint: false
    }
  },
  computed: {
    ...mapState(['clearOptions'])
  },
  watch: {
    clearOptions (val) {
      if (val) {
        this.radioStatus = false
      }
    },
    eventClick (val) {
      this.value = this.default
      this.num = this.numDefault
      this.text = this.textDefault
      this.radioStatus = val
    },
    radioStatus (val) {
      if (val == true) {
        this.changeOption()
      }
    },
    value (val) {
      this.changeOption()
    }
  },
  methods: {
    changeOption () {

      let value = ''

      if (this.radioStatus === true && this.value !== 'frame' && this.value !== 'image url') {
        value = this.value
      }

      if (this.radioStatus === true &&
          this.num &&
          this.value === 'frame' &&
          this.value !== 'image url') {
        value = parseFloat(this.num).toFixed(2)
      }

      if (this.radioStatus === true &&
        this.text &&
        this.text !== '' &&
        this.value !== 'frame' &&
        this.value === 'image url') {
        value = this.text
      }
      console.log(value)
      this.$emit('changeOption', {
        parameter: `${this.parameter}`,
        separator: ':',
        value: value
      })
    }
  }
}
</script>
